import { render, staticRenderFns } from "./mobile-header-head.vue?vue&type=template&id=0637441c&scoped=true"
import script from "./mobile-header-head.vue?vue&type=script&lang=js"
export * from "./mobile-header-head.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-head.vue?vue&type=style&index=0&id=0637441c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637441c",
  null
  
)

export default component.exports